document.querySelectorAll('[data-vimeo-poster-fallback]').forEach((button) => {
  const videoId = button.getAttribute('data-vimeo-poster-fallback');

  fetch(`https://vimeo.com/api/oembed.json?width=1920&url=${encodeURIComponent(`https://vimeo.com/${videoId}`)}`)
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const placeholder = button.querySelector('.placeholder-svg');
      if (!data || !data.thumbnail_url || !placeholder) return;

      const img = document.createElement('img');
      img.src = data.thumbnail_url;
      img.alt = button.getAttribute('aria-label') || '';
      img.loading = 'lazy';
      placeholder.replaceWith(img);
    })
    .catch(() => {});
});
